<template>
    <div>
        <img
            alt="Ideasfundx logo"
            src="../../../../assets/img/m-2.png"
            class=""
        />

        <div class="mt-3">
            <v-row class="mb-n8 my-0">
                <v-col cols="12" sm="10" md="10" lg="2">
                    <p class="text-sm-left mt-3 font-weight-light text-black my-0">Industry sector</p>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="8" class="py-0 py-sm-4">
                    <v-combobox
                        v-model="type.industry"
                        class="text-bold"
                        :items="allIndustries"
                        outlined
                        dense
                        small-chips
                        multiple
                        deletable-chipsborder
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="mb-n8">
                <v-col cols="12" sm="10" md="10" lg="2">
                    <p class="text-sm-left mt-2 font-weight-light text-black my-0">Business Model</p>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="8" class="py-0 py-sm-4">
                    <v-select
                        v-model="type.model"
                        class="text-bold"
                        :items="allModel"
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="mb-n8 py-0">
                <v-col cols="12" sm="10" md="10" lg="2">
                    <p class="text-sm-left mt-2 font-weight-light text-black my-0">Market Location</p>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="8" class="py-0 py-sm-4">
                    <v-combobox
                        v-model="type.location"
                        class="text-bold"
                        :items="allLocation"
                        outlined
                        dense
                        multiple
                        small-chips
                        deletable-chips
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="mb-n8">
                <v-col cols="12" sm="10" md="10" lg="2">
                    <p class="text-sm-left font-weight-light text-black my-0">
                        Addressable Market Size <span class="font-weight-regular">in Million USD</span>
                    </p>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="8" class="py-0 py-sm-4">
                    <v-text-field
                        disabled
                        prefix="$"
                        v-model="type_size"
                        class="text-bold text-right-input"
                        outlined
                        dense
                    />
                </v-col>
            </v-row>

            <v-row class="mb-n8">
                <v-col cols="12" sm="10" md="10" lg="2">
                    <p class="text-sm-left font-weight-light text-black my-0">Estimated market growth in the next 3 years</p>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="8" class="py-0 py-sm-4">
                    <v-text-field
                        disabled
                        prefix="%"
                        v-model="type_growth"
                        class="text-bold text-right-input"
                        outlined
                        dense
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
    import BusinessService from "@/store/services/business.service";
    import Var from "@/store/services/var";

    export default {
        props: {
            company_id: Number,
            type: Object,
            type_growth: String,
            type_size: String
        },
        components : {},
        data() {
            return {
                allIndustries: [],
                allModel: [],
                allLocation: [],
            }
        },

        mounted () {
            Var.getAllIndustries().then((res) => { this.allIndustries = res.data; })
            Var.getAllBusinessModel().then((res) => { this.allModel = res.data; })
            Var.getAllLocations().then((res) => { this.allLocation = res.data; })

            BusinessService.getType(this.company_id).then((res) => {
                this.type = res.data;
                this.type_size = res.data.size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.type_growth = res.data.growth.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            })
        }
    }
</script>
